import { useTranslation } from 'react-i18next';

import { ConfirmationModal } from '@/modules/common/components/modals/confirmation-modal';
import { IntegrationConflictsAdministrator } from '@/modules/common/types/integration-conflicts';

interface DataConflictsModalProps {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  administrators: IntegrationConflictsAdministrator[];
}

/**
 * Tells a user who can't resolve data conflicts which administrators to contact.
 */
export function DataConflictsModal({
  open,
  onOpen,
  onClose,
  administrators,
}: DataConflictsModalProps) {
  const { t } = useTranslation(['authenticated.settings', 'common']);

  const messageContent =
    administrators.length > 0 ? (
      <div className="space-y-3">
        <p>{t('authenticated.settings:pages.integrations.dataConflicts.contactAdministrators')}</p>
        <ul className="space-y-1">
          {administrators.map(({ name, email }) => (
            <li key={`${name}-${email ?? ''}`} className="font-medium text-foreground">
              {email
                ? t('authenticated.settings:pages.integrations.dataConflicts.administrator', {
                    name,
                    email,
                  })
                : name}
            </li>
          ))}
        </ul>
      </div>
    ) : (
      <p>
        {t(
          'authenticated.settings:pages.integrations.dataConflicts.contactOrganizationAdministrator'
        )}
      </p>
    );

  return (
    <ConfirmationModal
      title={t('authenticated.settings:pages.integrations.dataConflicts.title')}
      message={messageContent}
      confirmText={t('common:close')}
      confirmVariant="default"
      hideCancelButton
      onConfirm={closeModal => closeModal()}
      open={open}
      onOpen={onOpen}
      onClose={onClose}
    />
  );
}
